import * as AT from '../constants/actionTypes'

/**
 * Profile reducer
 * @param {*} state 
 * @param {*} action 
 */
const initialProfileState = {
	isAuthenticated: false,
	visitorTerritory: '',
	line: '',
	mfaRequired: false,
	mfaTicket: null,
	mfaUsername: null
};

function profile(state = initialProfileState, action) {
	switch (action.type) {
		case AT.PROFILE_LOGIN_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				error: undefined
				// keep mfaRequired/mfaTicket/mfaUsername so "Resend code" stays on MFA screen
			})
    	case AT.PROFILE_LOGIN_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error,
				mfaRequired: false,
				mfaTicket: null,
				mfaUsername: null
			})
		case AT.PROFILE_LOGIN_MFA_REQUIRED:
			return Object.assign({}, state, {
				isLoading: false,
				error: undefined,
				mfaRequired: true,
				mfaTicket: action.payload.ticket,
				mfaUsername: action.payload.username
			})
		case AT.PROFILE_VERIFY_MFA_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				error: undefined
			})
		case AT.PROFILE_VERIFY_MFA_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.PROFILE_MFA_CANCELLED:
			return Object.assign({}, state, {
				mfaRequired: false,
				mfaTicket: null,
				mfaUsername: null,
				error: undefined
			})
    	case AT.PROFILE_LOGIN_FINISHED: {
			const ninetyMinutesMs = 90 * 60 * 1000;
			const profileData = action.payload.profile;
			localStorage.setItem('token', profileData.token);
			return Object.assign({}, state, {
				isLoading: false,
				isAuthenticated: true,
				visitorTerritory: profileData.visitorTerritory,
				line: profileData.line,
				id: profileData.id,
				username: profileData.name,
				token: profileData.token,
				role: profileData.role,
				error: undefined,
				sessionExpiresAt: Date.now() + ninetyMinutesMs,
				mfaRequired: false,
				mfaTicket: null,
				mfaUsername: null
			});
		}
		case AT.PROFILE_SESSION_EXTENDED: {
			const ninetyMinutesMs = 90 * 60 * 1000;
			return Object.assign({}, state, {
				sessionExpiresAt: Date.now() + ninetyMinutesMs
			});
		}
		case AT.PROFILE_LOGOUT:
			localStorage.setItem('token', undefined);
			return Object.assign({}, state, {
				isLoading: false,
				isAuthenticated: false,
				visitorTerritory: '',
				line: '',
				id: undefined,
				username: undefined,
				token: undefined,
				role: undefined,
				error: undefined,
				sessionExpiresAt: undefined,
				mfaRequired: false,
				mfaTicket: null,
				mfaUsername: null
			});			
		default:
			return state;
	}
}

export default profile;